import React from 'react'
import PropTypes from 'prop-types'
import { useMediaQuery, LazyImage } from '@offerzen/pinata-shame'

import Container from '../Container'
import MobileNavMenu from '../MobileNavMenu'
import NavMenu from '../NavMenu'
import NavVisibilityBadge from '../NavVisibilityBadge'
import MobileNavVisibilityBadge from '../MobileNavVisibilityBadge'

import styles from './styles'

const Navbar = ({ candidateSlug, metadata, trackVisibilityStatus, signOut }) => {
  const { isPhoneOrLarger, isDesktopOrLarger } = useMediaQuery()

  return (
    <nav className={styles.wrapper}>
      <Container className={styles.container}>
        <a href="/" className={styles.logo}>
          <LazyImage className={styles.logoImage} loader={() => import('../../../assets/offerzen-logo.svg')} />
        </a>

        <div className={styles.navItems}>
          <Choose>
            <When condition={isDesktopOrLarger}>
              <If condition={metadata.currentState}>
                <NavVisibilityBadge
                  currentState={metadata.currentState}
                  trackVisibilityStatus={action => trackVisibilityStatus(action, 'desktop')}
                />
              </If>

              <NavMenu
                candidateSlug={candidateSlug}
                candidateState={metadata.currentState}
                disabledCandidate={metadata.disabled}
                unreadInterviewRequestCount={metadata.unreadIrMessages}
                signOut={signOut}
                emailPreferencesAccessTokenKey={metadata.emailPreferencesAccessTokenKey}
              />
            </When>

            <Otherwise>
              <If condition={metadata.currentState}>
                <MobileNavVisibilityBadge
                  currentState={metadata.currentState}
                  trackVisibilityStatus={action => trackVisibilityStatus(action, isPhoneOrLarger ? 'tablet' : 'mobile')}
                />
              </If>

              <MobileNavMenu
                candidateSlug={candidateSlug}
                candidateState={metadata.currentState}
                candidateAvailabilitySet={metadata.availabilitySet}
                disabledCandidate={metadata.disabled}
                unreadInterviewRequestCount={metadata.unreadIrMessages}
                signOut={signOut}
                emailPreferencesAccessTokenKey={metadata.emailPreferencesAccessTokenKey}
              />
            </Otherwise>
          </Choose>
        </div>
      </Container>
    </nav>
  )
}

Navbar.propTypes = {
  trackVisibilityStatus: PropTypes.func,
  signOut: PropTypes.func,
  metadata: PropTypes.shape({
    currentState: PropTypes.string,
    availabilitySet: PropTypes.bool,
    disabled: PropTypes.bool,
    unreadIrMessages: PropTypes.number,
    emailPreferencesAccessTokenKey: PropTypes.string,
  }),
  candidateSlug: PropTypes.string,
}

export default Navbar
